<nz-modal
  [(nzVisible)]="isVisible"
  [nzTitle]="'Admission details' | translate"
  [nzFooter]="null"
  (nzOnCancel)="handleCancel()"
  class="custom-modal-class"
>
  <ng-container *nzModalContent>
    <div class="summary-grid" *ngIf="summary; else noData">
      <div class="row">
        <div class="label">{{ "Admission Reason" | translate }}</div>
        <div class="value">{{ summary.admissionReason || "-" }}</div>
      </div>

      <div class="row">
        <div class="label">{{ "Registration Date" | translate }}</div>
        <div class="value">
          {{ summary.registrationDate | date : "medium" }}
        </div>
      </div>

      <div class="row" *ngIf="summary?.dischargeDate">
        <div class="label">{{ "Discharge Date" | translate }}</div>
        <div class="value">
          {{ summary.dischargeDate | date : "medium" }}
        </div>
      </div>

      <div class="row">
        <div class="label">{{ "Admission Notes" | translate }}</div>
        <div class="value prewrap">
          {{ summary.admissionNotes || "-" }}
        </div>
      </div>

      <div class="row">
        <div class="label">{{ "Move Bed Notes" | translate }}</div>
        <div class="value prewrap">
          {{ summary.moveBedNotes || "-" }}
        </div>
      </div>
    </div>

    <ng-template #noData>
      <div class="empty">
        <i nz-icon nzType="info-circle" nzTheme="outline"></i>
        <span>{{ "No admission info available" | translate }}</span>
      </div>
    </ng-template>
  </ng-container>
</nz-modal>
